var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeftSparkles375(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 74,
    viewBox: "0 0 75 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8177 53.4501C21.5732 52.7571 19.1918 54.0148 18.4988 56.2593C17.8058 58.5038 19.0635 60.8851 21.308 61.5782C23.5525 62.2712 25.9339 61.0135 26.6269 58.769C27.3199 56.5245 26.0622 54.1431 23.8177 53.4501Z",
    fill: "#3897FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3356 20.4858L67.4345 27.5689L73.9757 31.0025L66.8925 33.1014L63.459 39.6426L61.3597 32.5597L54.8189 29.1259L61.902 27.0269L65.3356 20.4858Z",
    fill: "#FFCC00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0154 20L30.6699 24.754L38.0204 24.0154L33.2659 29.67L34.0049 37.0204L28.3504 32.2663L20.9999 33.0049L25.7539 27.3506L25.0154 20Z",
    fill: "#8E4DD5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftSparkles375);
export default __webpack_public_path__ + "static/media/leftSparkles375.984a862e531e1fe5eaa1429c9be59f30.svg";
export { ForwardRef as ReactComponent };